import storeRoot from '../store-root'
import http from '../../services/http'
import queryString from 'querystring'

const moduleName = 'maps'

storeRoot.registerModule(moduleName, {
  namespaced: true,
  state: {

  },
  actions: {
    // // 获取设备位置信息
    // async getDeviceLocation ({commit}, payload) {
    //   let result = await http.get(`/api/Equipment/GetDeviceLocation?${queryString.stringify(payload)}`)
    //   return (result.data)
    // },
    // 获取设备位置信息分页列表
    async getDeviceLocationList ({commmit}, payload) {
      let result = await http.get(`/api/Equipment/GetDeviceLocationList?${queryString.stringify(payload)}`)
      return (result.data)
    },
    // 设备信息列表
    async getDeviceLocation ({commit}, payload) {
      let result = await http.get(`/api/Equipment/GetDeviceLocationByEnters?${queryString.stringify(payload)}`)
      return (result.data)
    },
    async getMapEquipmentList ({commit}, payload) {
      let result = await http.get(`/api/Equipment/GetEquipmentList`)
      return (result.data)
    }

  }

})

export default moduleName
